import { render, staticRenderFns } from "./bottom_nav.vue?vue&type=template&id=d0af451e&scoped=true"
import script from "./bottom_nav.vue?vue&type=script&lang=js"
export * from "./bottom_nav.vue?vue&type=script&lang=js"
import style0 from "./bottom_nav.vue?vue&type=style&index=0&id=d0af451e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0af451e",
  null
  
)

export default component.exports